export const TWO_FACTOR_CONFIG = {
  baseURL: 'https://api.monrapidoo.com/auth-2fa',
  serviceName: 'rapidoo',
  serviceGroup: 'ultraxeno',
  secretotpfree: '5564554655',
}

